<template>
  <div class="admin-file-upload">
    <div class="admin-file-upload__toolbar">
        <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" @click="launchFilePicker" :disabled="isUploadDisabled">
            <admin-icon name="upload" aria-hidden="true"></admin-icon>
            <span>{{buttonText}}</span>
        </button>
    </div>

    <input type="file" class="admin-file-upload__native" ref="file" v-uploader />

    <file-upload-progress :progress="progress"></file-upload-progress>
    <button
        type="button"
        class="btn btn-sm admin-file-upload__cancel"
        @click="cancelUpload"
        v-tooltip="trans('upload.cancel_upload')"
        v-if="progress || isFileSelected"
        :aria-label="trans('upload.cancel_upload')"
    >
        <admin-icon name="trash" aria-hidden="true"></admin-icon>
    </button>

    <ul class="admin-file-upload__list" v-if="uploaded_files && uploaded_files.length">
        <li v-for="uploaded_file in uploaded_files" :key="uploaded_file.id" class="admin-file-upload__item">
            <span class="admin-file-upload__name">
                <admin-icon name="file" aria-hidden="true"></admin-icon>
                {{uploaded_file.user_filename}}
            </span>
            <button
                type="button"
                class="admin-file-upload__delete"
                v-confirm="{ok: confirmDelete(uploaded_file)}"
                v-tooltip="trans('general.delete_upload')"
                :aria-label="trans('general.delete_upload')"
            >
                <admin-icon name="trash" aria-hidden="true"></admin-icon>
            </button>
        </li>
    </ul>
  </div>
</template>

<script>
    import fileUploadProgress from './file-upload-progress.vue'

    export default {
        components : { fileUploadProgress },
        props: {
            buttonText: {
                default: 'Choose File',
            },
            token: {
                required: true
            },
            module: {
                required: true
            },
            moduleId: {
                default: ''
            },
            clearFile: {
                default: false
            }
        },
        directives: {
            uploader: {
              bind(el, binding, vnode) {
                el.addEventListener('change', e => {
                  vnode.context.file = e.target.files[0];
                });
              }
            },
        },
        watch: {
            file(file){
                let fileExtension = file.name.substr((file.name.lastIndexOf('.') + 1));

                if(this.allowed_file_extensions.indexOf(fileExtension) == -1){
                    toastr.error(i18n.general.file_not_allowed);
                    this.isUploadDisabled = false;
                } else if(file.size > helper.getConfig('post_max_size')){
                    toastr.error(i18n.general.file_too_large);
                    this.isUploadDisabled = false;
                } else {
                    let formData = new FormData();
                    formData.append('file', file);
                    formData.append('token', this.token);
                    formData.append('module', this.module);
                    formData.append('module_id', this.moduleId || '');
                    axios.post('/api/upload',formData, {
                        onUploadProgress: progressEvent => {
                            this.progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                        }
                    }).then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.uploaded_files.push(response.upload);
                    }).catch(error => {
                        if(error.response.status == 413)
                            toastr.error(i18n.general.file_too_large);
                        else
                            helper.showDataErrorMsg(error);
                    }).then(() => {
                        this.progress = 0;
                        this.isUploadDisabled = false;
                    });
                    this.$refs.file.value = '';
                }
            },
            clearFile(val){
                this.uploaded_files = [];
            },
            moduleId(val){
                if(val)
                    this.fetchUploads();
            }
        },
        mounted(){
            if(this.moduleId)
                this.fetchUploads();

            axios.post('/api/upload/extension',{module: this.module})
                .then(response => response.data)
                .then(response => {
                    this.allowed_file_extensions = response;
                })
                .catch(error => {

                });
        },
        computed: {
            authToken(){
                return localStorage.getItem('auth_token');
            },
            isFileSelected(){
                return this.isUploadDisabled ? true : false;
            }
        },
        methods: {
            launchFilePicker() {
                this.isUploadDisabled = true;
                this.$refs.file.click();
            },
            cancelUpload(){
                if (this.request) {
                    this.request.abort();
                }
                this.isUploadDisabled = false;
            },
            confirmDelete(uploaded_file){
                return dialog => this.deleteUpload(uploaded_file);
            },
            deleteUpload(uploaded_file){
                axios.post('/api/upload/'+uploaded_file.id,{
                    token: uploaded_file.upload_token,
                    module_id: this.moduleId || ''
                }).then(response => response.data)
                .then(response => {
                    this.uploaded_files = this.uploaded_files.filter(function (item) {
                        return uploaded_file.id != item.id;
                    });
                    toastr.success(response.message);
                }).catch(error => {
                    helper.showDataErrorMsg(error);
                });
            },
            fetchUploads(){
                this.uploaded_files = [];
                axios.post('/api/upload/fetch',{
                    module: this.module,
                    module_id: this.moduleId
                })
                .then(response => response.data)
                .then(response => {
                    this.uploaded_files = response;
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                });
            }
        },
        data() {
            return {
              file: '',
              isUploadDisabled: false,
              progress: 0,
              uploaded_files: [],
              allowed_file_extensions: []
            }
        }
    }
</script>

